import { Box, Typography } from "@mui/material";
import TestJigsawDieLineOverlay from "./TestJigsawDieLineOverlay";
import { BOARD_SIZE, PieceVisual } from "./TestPieceVisual";

/** Copy of pages jigsaw CanvasPieces for admin canvas tests. */
export default function TestCanvasPieces({
    trayRef,
    piecesNotOnBoard,
    grid,
    imageUrl,
    paths,
    svgPathFallback,
    dragging,
    onTrayPieceMouseDown,
}) {
    const cellPx = BOARD_SIZE / grid;

    return (
        <Box sx={{ width: BOARD_SIZE }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Pieces — drag onto board anywhere; drop here to remove from board
            </Typography>
            <Box
                ref={trayRef}
                sx={{
                    position: "relative",
                    width: BOARD_SIZE,
                    height: BOARD_SIZE,
                    bgcolor: "grey.900",
                    borderRadius: 1,
                    overflow: "visible",
                }}
            >
                {piecesNotOnBoard.map((pieceIndex) => {
                    const isDraggingThis = dragging?.pieceIndex === pieceIndex && dragging?.fromTray;
                    return (
                        <div
                            key={pieceIndex}
                            onMouseDown={(e) => onTrayPieceMouseDown(e, pieceIndex)}
                            style={{
                                position: "absolute",
                                left: (pieceIndex % grid) * cellPx,
                                top: Math.floor(pieceIndex / grid) * cellPx,
                                cursor: "grab",
                                opacity: isDraggingThis ? 0.3 : 1,
                                zIndex: 1,
                            }}
                        >
                            <PieceVisual pieceIndex={pieceIndex} imageUrl={imageUrl} grid={grid} paths={paths} />
                        </div>
                    );
                })}
                <TestJigsawDieLineOverlay
                    pieces={paths}
                    opacity={0.6}
                    svgPathFallback={svgPathFallback}
                    zIndex={2}
                />
            </Box>
        </Box>
    );
}
